import { Button } from "@svea/design-system-components-react";
import { FormControlLabel, formatSsn, Stack, Text, useText } from "@sveabank/cc-common";
import type React from "react";
import Paper from "../../../../components/paper";
import type { ClcPerson } from "../../../../types/clc-application";

type Props = {
	person: ClcPerson;
	children: React.ReactNode;
	onDelete?: () => void;
	isApplicant?: boolean;
	isShareholder?: boolean;
};

const ClcPersonCard = ({ person, children, onDelete, isApplicant, isShareholder }: Props) => {
	const [t, texts] = useText();

	return (
		<Paper className={!isApplicant ? "bg-background-primary" : "bg-background-tertiary"}>
			<Stack gap={4}>
				<Stack direction="row" justify="between">
					<FormControlLabel aria-label={`${person.firstName} ${person.lastName}`}>
						<Stack direction="row" gap={4}>
							<Stack>
								<Text bold>{`${person.firstName} ${person.lastName}`}</Text>
								{isShareholder && <Text>{t(texts.newCompany.shareholder)}</Text>}
								<Text>{formatSsn(person.nationalId)}</Text>
							</Stack>
						</Stack>
					</FormControlLabel>
					{onDelete ? (
						<Button
							variant="icon"
							icon="trash"
							onPress={() => {
								onDelete();
							}}
							aria-label={t(texts.common.remove)}
						/>
					) : null}
				</Stack>
				{children}
			</Stack>
		</Paper>
	);
};

export default ClcPersonCard;
